// src/services/gonderiKapanisKapisi.ts
//
// GÖNDERİ COMPOSER'ININ KAPANIŞ KAPISI — "şimdi kapanabilir miyim?"
//
// ── NEDEN VAR (P0-6, ölçülmüş sessiz veri kaybı) ─────────────────────────
// `NewPost` kapanışı TEK kapıdan geçiriyordu (`kapatmayiIste`: içerik varsa
// onay sorar). Escape ve ✕ o kapıdan geçiyordu; **tarayıcı GERİ tuşu
// geçmiyordu** — `appRouting.usePopstateHandler` composer'ı doğrudan
// `setModalContent(null)` ile kapatıyordu. `writeDraft` yalnız
// `mesaj/konum/altText` sakladığı için (NewPost.tsx:125) seçilen medya
// SESSİZCE gidiyordu. Ölçüm (`src/gonderiGeriTusuTaslakKapisi.render.test.tsx`,
// düzeltmeden önce):
//
//     onay=0 · composer=YOK · küçük resim 1 → 0 · yol=/
//
// ── NEDEN MODÜL-DÜZEYİ KAPI (soru router'a taşınmadı) ────────────────────
// Soru metni ve "kaybolacak bir şey var mı" kararı bileşenin state'ine
// bağlıdır (`items`, `mesaj`, `altText`, `konum`, `venueSel`, `taggedUsers`).
// Router'a kopyalamak aynı kuralı iki yere yazmak olurdu — kanon: *"iki yerde
// yazılan aynı kural, iki farklı kuraldır; henüz değil ama er ya da geç."*
// Emsal İCAT EDİLMEDİ: router zaten `services/postUploadGuard.isPostUploading()`
// ile birebir bu biçimde bir modül-düzeyi kapıyı okuyor.
//
// ── ÜÇ HÂL AYRI (TEMİZ · RED · ÖLÇEMEDİM) ───────────────────────────────
// · Kapı "evet" der            → kapanabilir.
// · Kapı "hayır" der           → kapanma REDDEDİLİR (kullanıcı vazgeçti).
// · Kapı KAYITLI DEĞİL         → **kapanabilir**. Gerekçe ölçülebilir: taslak
//   composer'ın kendi state'inde yaşar, yani KAYITÇI MOUNT DEĞİLKEN TASLAK DA
//   YOKTUR (`NewPost` lazy yüklenirken açılan pencere tam olarak budur).
//   Burada reddetmek, hiç veri yokken geri tuşunu ölü bırakırdı.
// · Kapı PATLADI               → kapanma REDDEDİLİR. Ölçemediğimiz için
//   geri-alınamaz yöne (medya kaybı) düşmeyiz; kullanıcının elinde ✕ kapısı
//   duruyor, yani kapalı yön geri alınabilir. (`NewPost.onay` zaten aynı
//   kararı veriyor: `window.confirm` yoksa KAPATMA.)

/** `true` → kapanabilir. `false` → kapanma reddedildi. */
export type GonderiKapanisKapisi = () => boolean;

let kapi: GonderiKapanisKapisi | null = null;

/** Kaydeder ve KAYIT SİLME fonksiyonunu döner (effect cleanup'ında çağrılır). */
export function gonderiKapanisKapisiniKaydet(k: GonderiKapanisKapisi): () => void {
  kapi = k;
  return () => { if (kapi === k) kapi = null; };
}

export function gonderiKapanabilirMi(): boolean {
  if (!kapi) return true;          // ÖLÇEMEDİM-A: kayıtçı yok ⇒ taslak da yok
  try {
    return kapi() !== false;
  } catch {
    return false;                  // ÖLÇEMEDİM-B: geri-alınamaz yöne düşme
  }
}

/** Yalnız ölçüm/teşhis: kapı bağlı mı? */
export function gonderiKapanisKapisiBagliMi(): boolean {
  return kapi !== null;
}
